import { Controller } from "stimulus";

export default class HeroController extends Controller {
  connect() {
    console.log("Hello, Stimulus", this.element);
  }


  greet() {
    console.log("Greetings!")
  }

  showModal() {
      document.dispatchEvent(new CustomEvent('registrationModal.show'), { detail: { someData: true } });
  }
}
